/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Company } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface CompanyServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get Companies
     * Returns the list of companies
     */
    getCompanies(extraHttpRequestParams?: any): Observable<Array<Company>>;

    /**
     * Get Company by id
     * Returns the Company with the specified id.
     * @param id The company of the given company id.
     */
    getCompanyById(id: number, extraHttpRequestParams?: any): Observable<Company>;

}
